import { Box, Button, Grid, Typography } from '@mui/material'
import { isEmpty } from 'lodash'
import { useHistory } from 'react-router-dom'

import { ROUTES_PATHS } from 'core/routes'
import {
  OnboardingPage,
  OnboardingQuestionType,
} from 'enums/onboardingQuestion'
import { t } from 'i18n'
import { getUnansweredQuestions } from '../../utils'

export default function OnboardingPagination({
  answers,
  setAnswers,
  pages,
  pagination,
  setPagination,
  finishOnboarding,
  saveProfileQuestions,
  profileState,
  isSupervisorView,
  userId,
  getProfileSettingsAnswers
}) {
  const history: any = useHistory()

  const handleNextPage = () => {
    if (pagination === OnboardingPage.ProfileQuestions && !isSupervisorView) {
      saveProfileQuestions()
    }

    if (pagination === OnboardingPage.ProfileSettings) {
      const profileSettingsAnswer = getProfileSettingsAnswers(profileState)
      const otherAnswers = answers.filter(a => a.type !== OnboardingQuestionType.ProfileSettings)
      const updatedAnswers = [...otherAnswers, profileSettingsAnswer]
      setAnswers(updatedAnswers)
    }

    setPagination(pages[pages.indexOf(pagination) + 1])
  }

  const handleFinish = () => {
    const profileSettingsAnswer = getProfileSettingsAnswers(profileState)
    const otherAnswers = answers.filter(a => a.type !== OnboardingQuestionType.ProfileSettings)
    const finalAnswers = [...otherAnswers, profileSettingsAnswer]

    setAnswers(finalAnswers)
    finishOnboarding(finalAnswers)
  }

  const isFirstPage = () => pagination === pages[0]
  const isLastPage = () => pagination === pages[pages.length - 1]

  const isNextPageButtonDisabled = () => {
    if (isSupervisorView) return false

    return !isEmpty(getUnansweredQuestions(pagination, answers))
  }

  const nextPageButtonDisabled = !!isNextPageButtonDisabled()

  return (
    <Box my={3}>
      <Grid container justifyContent='center' spacing={2}>
        {!isFirstPage() && (
          <Grid item>
            <Button
              variant='outlined'
              color='primary'
              onClick={() => {
                window.scrollTo(0, 0)
                setPagination(pages[pages.indexOf(pagination) - 1])
              }}
              size='large'
            >
              {t('onboarding.pagination.previous')}
            </Button>
          </Grid>
        )}

        <Grid item>
          <Button
            sx={{ mb: 4 }}
            variant='contained'
            color='primary'
            onClick={() => {
              window.scrollTo(0, 0)
              if (isLastPage()) {
                if (isSupervisorView) {
                  history.push(`${ROUTES_PATHS.profile}/${userId}`)
                } else {
                  handleFinish()
                }
              } else {
                handleNextPage()
              }
            }}
            disabled={nextPageButtonDisabled}
            size='large'
          >
            {isFirstPage()
              ? t('onboarding.pagination.imReady')
              : isLastPage()
                ? isSupervisorView
                  ? t('onboarding.pagination.backToProfile')
                  : t('onboarding.pagination.finish')
                : t('onboarding.pagination.next')}
          </Button>
        </Grid>

        {nextPageButtonDisabled && (
          <Grid item xs={12}>
            <Typography
              variant='body2'
              color='error'
              align='center'
              data-cy='onboardingIncompleteWarning'
            >
              {t('onboarding.pagination.incompleteHelperText')}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  )
}
